const system_limit = {
    limit_exceeded: 'لقد وصلت إلى الحد الأقصى للنظام. يُرجى التواصل مع الدعم للحصول على المساعدة.',
};
export default Object.freeze(system_limit);
